<template>
    <div class="section-index">
        <!--banner-->
        <div class="con-banner">
            <swiper :options="swiperOption" ref="mySwiper" class="home-swiper">
                <!--五周年活动临时添加-->
               <!--<swiper-slide class="fiveyear">-->
                   <!--<router-link to="/en/order" _src="/static/image/swiper/index/fiveyear_banner@2x.jpg"></router-link>-->
                <!--</swiper-slide>-->
                <!--平时轮播-->
                <swiper-slide class="banner1" _src="/static/image/swiper/index/index-banner1@2x.jpg">
                    <div class="banner-center common-font">
                        <div class="ban-pro center connect-pro">
                            <!--<div class="circle"></div>-->
                            <div class="ban-mes">
                                <p>One day</p>
                                <h1>Everything and everyone will transmit a signal</h1>
                                <!--<h1>will transmit a signal</h1>-->
                                <!--<h1>Connecting the Physical and Digital World</h1>-->
                            </div>

                        </div>
                    </div>
                </swiper-slide>
                <swiper-slide class="banner2" _src="/static/image/swiper/index/index-banner2@2x.jpg">
                    <div class="banner-center connect-banner common-font">
                        <div class="center">
                            <div class="connectMes ">
                                <h1>Connecting the Physical</h1>
                                <h1>and Digital World</h1>

                            </div>

                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
        <!--content-->
        <section class="section-cont">
            <div class="cont-center">
                <div class="apart-cont center">
                    <h1 class="common-font">What sets us apart</h1>
                    <div class="content-layout">
                        <div class="layout" v-for="(item,key) in contentMes" :key="key">
                            <img :src="item.url" alt="" :_src="item._url">
                            <h3 class="common-font">{{item.title}}</h3>
                            <p>{{item.content}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!--product-->
            <div class="product-cont center common-font">
                <h1>Products</h1>
                <div class="product-mes">
                    <div class="mes-left">
                        <a href="/en/Alpha#AlphaStation">
                            <img src="/static/image/index/index-Basestation@1x.png"
                                 _src="/static/image/index/index-Basestation@2x.png" alt="">
                            <div class="station-mes">
                                <div class="station-cont">
                                    <h3>Alpha Base Station</h3>
                                    <p>IoT Core Infrastructure</p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="mes-right">
                        <a href="/en/Alpha#AlphaStation">
                            <div class="right-gateway">
                                <img src="/static/image/index/index-Gateway@1x.png"
                                     _src="/static/image/index/index-Gateway@2x.png" alt="">
                                <div class="gateway-mes">
                                    <h3>Alpha Gateway</h3>
                                </div>
                            </div>
                        </a>
                        <div class="right-module">
                            <a href="/en/Alpha#AlphaModule">
                                <img src="/static/image/index/index-Module@1x.png"
                                     _src="/static/image/index/index-Module@2x.png" alt="">
                                <div class="module-mes">
                                    <h3>Alpha Chipset</h3>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <!--<span class="learn-more">Click to see more of our products-->
                <!--<router-link to="/en/product">More +</router-link>-->
                <!--</span>-->
            </div>
            <!--case-->
            <div class="case-cont clearfix">
                <div class="Case-index clearfix">
                    <div class="caseTab-center">
                        <h2 class="common-font">Case Studies</h2>
                        <changeTab :items="themes"></changeTab>
                        <router-link to="/en/case" class="learn-case">More +</router-link>
                    </div>
                </div>
                <changeImg :imgs="themes"></changeImg>
            </div>
            <!--concact-->
            <div class="concact-cont">
                <div class="addr-cont center">
                    <h1 class="common-font">Contact</h1>
                    <addr></addr>
                </div>
            </div>
            <!--map-->
            <div class="map-cont">
                <div class="map-detail center">
                    <img src="/static/image/index/map@1x.png" _src="/static/image/index/map@2x.png" alt="">
                    <div class="map-mes">
                        <h2 class="common-font">Our Network</h2>
                        <p>We serve more than 65 countries and regions all over the world</p>
                    </div>
                    <!--<ChangeMap :maps="maps"></ChangeMap>-->
                </div>

            </div>
        </section>

    </div>
</template>

<script>

    // import swiper1 from '../common/swiper'
    import {swiper, swiperSlide} from 'vue-awesome-swiper';
    import changeTab from '../common/changeTab';
    import changeImg from '../common/changeImg';
    import addr from '../common/addr';
    // import ChangeMap from '../common/ChangeMap';

    export default {
        name: "home",
        data() {
            return {
                // slides: [
                //     {url: '/static/image/swiper/index/xiaofang@1x.png'},
                //     {url: '/static/image/swiper/index/xiaofang@1x.png'},
                //     {url: '/static/image/swiper/index/index-banner1@1x.jpg'},
                //     {url: '/static/image/swiper/index/xiaofang@1x.png'}
                // ],
                // maps: ['China', 'United States', 'Japan', 'Australia', 'Brazil', 'Germany', 'Russia', 'India', 'United Kingdom'],
                themes: [
                    {
                        title: 'Ningbo Protection',
                        isActive: true,
                        url: '/static/image/swiper/index/Ningbo-Protection@1x.jpg',
                        url1: '/static/image/swiper/index/Ningbo-Protection@2x.jpg'
                    },
                    {
                        title: 'Potala Palace',
                        isActive: false,
                        url: '/static/image/swiper/index/Potala-Palace@1x.jpg',
                        url1: '/static/image/swiper/index/Potala-Palace@2x.jpg',
                    },
                    {
                        title: 'Forbidden City Museum',
                        isActive: false,
                        url: '/static/image/swiper/index/Forbidden-City-Museum@1x.jpg',
                        url1: '/static/image/swiper/index/Forbidden-City-Museum@2x.jpg'

                    },
                    {
                        title: 'Nanjing Fire Protection',
                        isActive: false,
                        url: '/static/image/swiper/index/Nanjing-Fire-Protection@1x.jpg',
                        url1: '/static/image/swiper/index/Nanjing-Fire-Protection@2x.jpg'
                    }
                ],
                contentMes: [
                    {
                        url: '/static/image/index/Iot@1x.png',
                        _url: '/static/image/index/Iot@2x.png',
                        title: 'Alpha',
                        content: 'Alpha Base Stations and networks that support ultra-large scale battery-driven sensors , with the lowest power consumption and maintenance costs.'
                    },
                    {
                        url: '/static/image/index/Beacons@1x.png',
                        _url: '/static/image/index/Beacons@2x.png',
                        title: 'Beacons',
                        content: 'Simple, efficient and practical multi-purpose sensors for smart buildings, municipalities, and fire protection. Ultra-low power consumption,  ultra-long coverage and long battery life.'
                    }
                ],
                swiperOption: {
                    notNextTick: true,
                    // swiper configs 所有的配置同swiper官方api配置
                    autoplay: true,
                    speed: 3000,
                    loop: 'true',
                    direction: 'horizontal',
                    // grabCursor : true,
                    // autoHeight: true,
                    paginationClickable: true,
                    setWrapperSize: true,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: 'true',

                    }
                },
            }
        },
        components: {
            swiper,
            swiperSlide,
            changeTab,
            changeImg,
            addr,
        },
        computed: {
            mySwiper() {
                return this.$refs.mySwiper.swiper;
            }
        },
        created() {
        },
        mounted() {
            //这边可以使用swiper这个对象去使用swiper官网中的那些方法
            // this.mySwiper.slideTo(0, 0, false);
            this.utils.getImg()
        },
        methods: {},
        // tabsSwitch: function(tabIndex) {
        //     var tabCardCollection = document.querySelectorAll(".tab-card"),
        //         len = tabCardCollection.length;
        //
        //     for(var i = 0; i < len; i++) {
        //         tabCardCollection[i].style.display = "none";
        //         this.themes[i].isActive = false;
        //     }
        //     this.themes[tabIndex].isActive = true;
        //     tabCardCollection[tabIndex].style.display = "block";
        // }
        // }


    }
</script>

<style lang="less">
    @baseWidth: 1640px;
    @baseColor: #252525;
    .section-index {
        width: 100%;
        .center {
            width: @baseWidth;
            margin: 0 auto;
        }
        .common-font {
            font-family: 'Gotham-Medium', "Avenir Next", 'Helvetica Neue', 'PingFang SC';
            font-weight: 500;
        }
        .con-banner {
            position: relative;
            width: 100%;
            height: 750px;
            overflow: hidden;
            /*五周年活动临时轮播图*/
            .fiveyear{
                height: 750px;
                a{
                    display: block;
                    width: 100%;
                    height: 100%;
                    background: url("/static/image/swiper/index/fiveyear_banner@1x.jpg") no-repeat center;
                    background-size: cover;
                }

            }
            /*平时轮播图*/
            .banner1 {
                width: 100%;
                height: 750px;
                background: url("/static/image/swiper/index/index-banner1@1x.jpg") no-repeat center;
                background-size: cover;
            }
            .banner2 {
                width: 100%;
                height: 750px;
                background: url("/static/image/swiper/index/index-banner2@1x.jpg") no-repeat center;
                background-size: cover;
            }
            .banner-center {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 750px;

                .ban-pro {
                    position: relative;
                    height: 750px;
                    color: #fff;
                    line-height: 48px;
                    display: flex;
                    align-items: center;
                    .ban-mes {
                        align-items: center;
                        /*position: absolute;*/
                        /*top: 50%;*/
                        /*left: 50%;*/
                        /*margin-left: -332px;*/
                        /*margin-top: -140px;*/
                        margin: -180px auto 0;
                        text-align: center;
                        /*height: 750px;*/

                        p {
                            font-size: 40px;
                            margin-bottom: 8px;
                            /*font-weight: 500;*/
                        }
                        h1 {
                            font-size: 32px;
                        }
                    }

                }
            }
            .connect-banner {
                .center {
                    width: @baseWidth;
                    margin: 0 auto;
                    height: 100%;
                    display: flex;
                    align-items: center;
                }
            }
            .connectMes {
                /*position: absolute;*/
                /*top: 43%;*/
                /*left: 0;*/
                width: 600px;
                color: #fff;
                font-size: 32px;
                margin-left: 284px;
                h1 {
                    line-height: 56px;
                }

            }
        }

    }

    .swiper-container {
        .swiper-slide {
            .home-swiper {
                height: 750px;
                width: 100%;
            }
        }
    }

    .con-banner {
        .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
            bottom: 48px;
            /*display: none;*/
            .swiper-pagination-bullet {
                width: 12px;
                height: 12px;
                /*margin-bottom: 38px;*/
                background: #fff;
            }
        }

        .swiper-pagination-bullet-active {
            background: #007aff;
        }

    }

    section {
        width: 100%;
        h1 {
            font-size: 28px;
            line-height: 48px;
        }
        p {
            /*font-size: 18px;*/
            font-size: 16px;
            color: #5D5D5D;
            line-height: 26px;
        }
        .cont-center {
            width: 100%;
            padding: 96px 0;
            text-align: center;
            background: #FAFAFA;

            h1 {
                /*font-size: 36px;*/
                color: @baseColor;
                /*line-height: 48px;*/
                /*font-weight: 500;*/
            }
            .content-layout {
                width: 1020px;
                margin: 63px auto 0;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .layout {
                    width: 45%;
                    color: #5D5D5D;
                    text-align: center;
                    h3 {
                        font-size: 24px;
                        line-height: 32px;
                        margin: 39px 0 24px;
                        color: #252525;
                    }
                    p {
                        /*font-size: 18px;*/
                        /*line-height: 26px;*/
                        white-space: normal;
                    }
                    img {
                        width: 100px;
                    }
                }
            }
        }
        /*=====product====*/
        .product-cont {
            width: 100%;
            padding: 0 140px 96px;
            /*font-weight: 500;*/
            h1 {
                text-align: center;
                color: @baseColor;
                margin-bottom: 56px;
                margin-top: 96px;
            }
            .product-mes {
                display: flex;
                img {
                    display: block;
                    width: 100%;
                    -webkit-transition: all .5s;
                    transition: all .5s;
                }
                h3 {
                    /*font-size: 28px;*/
                    font-size: 22px;
                    color: @baseColor;
                    line-height: 36px;
                }

                .mes-left {
                    width: 660px;
                    /*width: 100%;*/
                    height: 100%;
                    position: relative;
                    margin-right: 40px;
                    overflow: hidden;
                    transition: .3s;
                    .station-mes {
                        position: absolute;
                        bottom: 113px;
                        right: 79px;
                        .station-cont {
                            margin: 0 auto;
                        }
                    }
                    a {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        transition: .3s;
                    }
                }
                .mes-right {
                    transition: .3s;
                    a {
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                    }
                    .right-gateway {
                        margin-bottom: 40px;
                    }
                    .right-gateway, .right-module {
                        position: relative;
                        .gateway-mes {
                            position: absolute;
                            bottom: 42px;
                            left: 0;
                            width: 100%;
                            margin: 0 auto;
                            text-align: center;
                        }
                        .module-mes {
                            position: absolute;
                            top: 56px;
                            right: 0;
                            /*margin-right: -72px;*/
                            width: 100%;
                            text-align: center;
                        }
                    }
                }
                .mes-left, .mes-right {
                    width: 660px;
                    overflow: hidden;
                    a:hover {
                        width: 100%;
                        height: 100%;
                        box-shadow: 0 0 5px 0 rgba(0, 0, 0, .1);
                        img {
                            -webkit-transform: scale(1.03);
                            transform: scale(1.03);
                        }
                    }
                }
            }
            .learn-more {
                display: block;
                margin-top: 56px;
                margin-bottom: 96px;
                /*font-size: 18px;*/
                font-size: 16px;
                color: #5D5D5D;
                line-height: 26px;
                text-align: center;
                a {
                    color: #131313;
                    text-decoration: underline;
                }
            }
        }
        /*====case====*/
        .case-cont {
            /*position: relative;*/
            width: 100%;
            height: 580px;
            .Case-index {
                float: left;
                width: 50%;
                height: 100%;
                background: #252525;
                color: #fff;
                padding: 113px 0;
                .caseTab-center {
                    width: @baseWidth/2;
                    float: right;
                    padding-left: 140px;

                }
                h2 {
                    /*font-size: 36px;*/
                    font-size: 28px;
                    line-height: 48px;
                    /*font-weight: 500;*/
                }
                .tabs {
                    margin: 36px 0;
                    li:active {
                        transition: .3s;
                        color: #fff;
                    }
                    i {
                        display: inline-block;
                        margin-right: 8px;
                        color: #5D5D5D;
                        font-size: 14px;
                        line-height: 22px;
                    }
                    .tab-link {
                        text-decoration: none;
                        display: inline-block;
                        /*font-size: 28px;*/
                        font-size: 24px;
                        line-height: 44px;
                        color: #5D5D5D;
                        margin-bottom: 8px;
                        transition: .3s;
                        &.active {
                            /*transition: .3s;*/
                            color: #fff;
                            transition: .3s;
                            transform: translate(24px, 0);
                            font-weight: 500;
                        }
                    }
                }
                .learn-case {
                    font-size: 18px;
                    line-height: 26px;
                    color: #fff;
                    text-decoration: underline;
                    font-weight: 500;
                }
            }
            .img-pro {
                width: 50%;
                height: 100%;
                float: right;
                .case-img {
                    display: block;
                    width: 100%;
                    height: 580px;
                }
            }

        }
        /*====concact====*/
        .concact-cont {
            width: 100%;
            .addr-cont {
                margin: 96px auto;
                h1 {
                    color: #252525;
                    text-align: center;
                    margin-bottom: 56px;
                    /*font-weight: 500;*/
                }
            }
        }
        .map-cont {
            width: 100%;
            background: #fafafa;
            /*padding-bottom: 48px;*/
            padding: 84px 0 79px;
            .map-detail {
                position: relative;
                /*width: 10 0%;*/
                text-align: center;
            }
            img {
                height: 616px;
                margin: 0 auto;
            }
            .map-mes {
                position: absolute;
                bottom: 6.16%;
                left: 8.8%;
                text-align: left;
                h2 {
                    font-size: 28px;
                    color: #252525;
                    margin-bottom: 16px;
                    /*font-weight: 500;*/
                }
                p {
                    width: 302px;
                    color: #5D5D5D;
                }
            }
        }
    }

    @media screen and (max-width: 1680px) {
        @baseWidth: 1216px;
        @autoWidth: 1256px;
        .section-index {
            min-width: @autoWidth;
            .center {
                width: @baseWidth;
                margin: 0 auto;
            }
            .con-banner .connect-banner .center{
                width: @baseWidth;
                margin: 0 auto;

            }
            .con-banner{
                .connectMes{
                    margin-left: 72px;
                }
            }
            section {
                width: 100%;
                .product-cont {
                    padding: 0 140px 96px;
                    /*padding: 0;*/
                    img {
                        width: 452px;

                    }
                    .product-mes {
                        .mes-left {
                            margin-right: 32px;
                            .station-mes {
                                bottom: 72px;
                                right: 39px;
                            }
                        }
                        .mes-right {
                            .right-gateway {
                                margin-bottom: 28px;
                                .gateway-mes {
                                    bottom: 24px;
                                }
                            }
                            .right-module {
                                .module-mes {
                                    top: 32px;
                                }
                            }
                        }
                    }

                }
                .case-cont {
                    height: 500px;
                    .Case-index {
                        width: 50%;
                        /*padding-left: 140px;*/
                        padding: 70px 0 70px 140px;
                        .caseTab-center {
                            width: @baseWidth/2;

                        }
                    }
                    .img-pro{
                        .case-img{
                            height: 500px;
                        }
                    }
                }
                .concact-cont {
                    .addr-cont {
                        .addr-mes {
                            /*padding: 0 60px;*/
                            li h3 {
                                /*font-weight: 500;*/
                            }
                        }
                    }
                }
                .map-cont {

                    img {
                        height: 422px;
                        margin: 0 auto;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home.vue